// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZNCL1","left":"styles_left__3m1hF"};